import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject, BehaviorSubject } from 'rxjs';
import { Questions } from '../common-class/questions';
import { SaveOnNextData } from '../common-class/save-on-next-data';
import { Participation_Messages, SurveyMessages } from '../common-class/survey-messages';
import { GroupPiping, MatrixPiping, MatrixRandomiseList } from '../common-class/pages';
import { PreviewData, CommonSetting } from '../common-class/survey';
declare var $: any;
const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded'
  })
};

const httpFileOPtions = {
  headers: new HttpHeaders({
    'Accept': 'application/json'
  })
};

@Injectable({
  providedIn: 'root'
})

export class ParticipationDataService {

  basePath: string;
  path:string;
  isLoaded: boolean;
  surveykey: string;
  recno: number;
  GroupType: string;
  isRTL: boolean;
  // PRT 102718
  ReEnterBlankMessage: string;
  questions: Array<Questions> = [];
  groupPipings: Array<GroupPiping> = [];
  matrixPipings: Array<MatrixPiping> = [];
  matrixRandomiseList:  Array<MatrixRandomiseList> = [];
  preview : PreviewData;
  commonSetting : CommonSetting;
  surveyMessages: SurveyMessages;
  isEx: boolean;
  dropDownCount:number;
  ImageFolder:string;
  isCapchaManditorySkip: boolean;
  nextButtonClickNo: number;
  pageIsSoftRequiredHandle: any;
  geoLocation: string;
  productName: string;
  isNewParticipation: boolean;
  surveyFormat: number;
  rsInputValue: number;
  questionchange: Questions;
  private renderer: Renderer2;
  newParticipationBtnText: string;
  isAutoScroll: boolean;
  isMobile: boolean;
  selectedLanguageCulture: string;
  answerPipeMessage: string;
  CustomAttachmentSizeSurveyID : string;
  strSurveyID:string;
  strCorpNo:string;
  CurrencyNegativeValueMessage: string;
  selectedLanguageId: number = 0;
  MDDdropDownCount:number;
  isPrevPgChnge: boolean = false;

  constructor(public httpClient: HttpClient, private rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  private emitChangeSource = new Subject<Questions>();

  public emitFormSubmitEvent = new BehaviorSubject<boolean>(false);
  public emitResetPageEvent = new Subject<boolean>();

  changeEmitted$ = this.emitChangeSource.asObservable();

  emitChange(myMessage: string, isLoaded: boolean) {
    this.basePath = myMessage + 'AngularAPI/';
    this.isLoaded = isLoaded;
    this.path = myMessage;
  }

  getBasePath():string
  {
    return this.path;
  }

  setSureyDetails(surveykey: string, recno: number, GroupType: string,
    ReEnterBlankMessage: string, geoLocation: string, productName: string) {
    this.surveykey = surveykey;
    this.recno = recno;
    this.GroupType = GroupType;
    this.ReEnterBlankMessage = ReEnterBlankMessage;
    this.geoLocation = geoLocation;
    this.productName = productName;
  }

  setRTL(isRTL: boolean) {
    this.isRTL = isRTL;
  }

  setCustomAttachmentSizeSurveyID(CustomAttachmentSizeSurveyID : string)
  {
    this.CustomAttachmentSizeSurveyID = CustomAttachmentSizeSurveyID;
  }
  setSurveyID(strSurveyID:string)
  {
    this.strSurveyID = strSurveyID;
  }
  setCorpNo(strCorpNo:string)
  {
    this.strCorpNo = strCorpNo;
  }



  setMobile(isMobile:boolean)
  {
    this.isMobile = isMobile;
  }


  getSurveykey(): string {
    return this.surveykey;
  }

  setCurrencyNegativeMessage(message: string){
    this.CurrencyNegativeValueMessage = message;
  }

  getCurrencyNegativeMessage(): string{
    return this.CurrencyNegativeValueMessage;
  }

  getRecNO(): Number {
    return this.recno;
  }

  getGroupType(): string {
    return this.GroupType;
  }

  getRTL(): boolean {
    return this.isRTL;
  }
  getMobile():boolean
  {
    return this.isMobile;
  }

  // PRT 102718
  getReEnterBlankMessage(): string {
    return this.ReEnterBlankMessage;
  }

  setPreviewData(preview:PreviewData){
    return this.preview = preview;
  }
  getPreviewData(): PreviewData{
    return this.preview;
  }

  setCommonSetting(commonSetting: CommonSetting){
    this.commonSetting = commonSetting;
  }

  getCommonSetting() : CommonSetting{
    return this.commonSetting;
  }

  setSurveyMessages(surveyMessages:SurveyMessages)
  {
    this.surveyMessages =surveyMessages;
  }
  getSurveyMessages():SurveyMessages
  {
    return this.surveyMessages;
  }
  getIsEx():boolean
  {
    return this.isEx;
  }

  setIsEx(IsEx: boolean){
    this.isEx = IsEx;
  }

  getdropDownCount():number
  {
    return this.dropDownCount;
  }
  setdropDownCount(dropDownCount: number)
  {
      this.dropDownCount= dropDownCount
  }

  getImageFolder():string
  {
    return this.ImageFolder;
  }
  setImageFolder(ImageFolder: string)
  {
    this.ImageFolder=ImageFolder;
  }

  getMDDdropDownCount():number
  {
    return this.MDDdropDownCount;
  }
  setMDDdropDownCount(MDDdropDownCount: number)
  {
      this.MDDdropDownCount= MDDdropDownCount
  }

  public GetData(url: string): any {
    this.isLoaded = true;
    return this.httpClient.get<any>(this.basePath + url);
  }

  // public GetData(url: string): any {
  //   this.isLoaded = true;
  //   return this.httpClient.get<any>(url);
  // }

  public GetLocalData(url: string): any {
    this.isLoaded = true;
    return this.httpClient.get<any>(url);
  }

  public PostData(url: string, jsonData: string): any {
    return this.httpClient.post<SaveOnNextData>(this.basePath + url, jsonData, httpOptions);
  }

  public PostDataForSubmit(url: string, jsonData: string): any {
    return this.httpClient.post<Participation_Messages>(this.basePath + url, jsonData, httpOptions);
  }

  public PostErrorData(url: string, jsonData: string): any {
    return this.httpClient.post<any>(this.basePath + url, jsonData, httpOptions);
  }

  public JSErrorMail(url: string): any {
    return this.httpClient.post<any>(this.basePath + url, httpOptions);
  }

  public postDataUsingPromise(url: string, jsonData: string): any {
    return this.httpClient.post<any>(this.basePath + url, jsonData, httpOptions).toPromise();
  }

  public postAttachedFile(url: string, formData: FormData): any {
    return this.httpClient.post<any>(this.basePath + url, formData, httpFileOPtions);
  }

  public DeleteSignatureFile(url: string): any{
    return this.httpClient.post<any>(this.basePath + url, httpOptions);
  }

  public PostCloseEvent(url: string,jsonData: string): any{
    return this.httpClient.post<any>(this.basePath + url,jsonData, httpOptions);
  }

  public PostPartialDataMail(url: string)
  {
    return this.httpClient.post<any>(this.basePath + url, httpOptions);
  }
  public GetOfflineModeData(url: string):any
  {
    return this.httpClient.get<any>(this.basePath + url);
  }

  SetQDL(question: Questions) {
      let updateItem = this.questions.find(
        e => e.UniqueNumber == question.UniqueNumber); 
      if (updateItem != null && updateItem != undefined) {
        let index = this.questions.indexOf(updateItem);
        this.questions[index] = question;
      } else {
        this.questions.push(question);
      }
  }


  ExecureRuleExpression(question:Questions,ruleExp:string):boolean
  {
    let qdlCond = question.QDLCondStatuses;
    let ruleExpString = ruleExp;
   
    for(let i =0;i < qdlCond.length ; i++){
      if(ruleExpString.indexOf(qdlCond[i].CondName.trim()) > -1 )
      {
        if(qdlCond[i].Status == true)
        {
          //alert(qdlCond[i].CondName );
          ruleExpString= ruleExpString.replace(qdlCond[i].CondName.trim() , "1==1");
        }
        else
        {
          //alert(qdlCond[i].CondName );
          ruleExpString = ruleExpString.replace(qdlCond[i].CondName.trim() , "1==0");
        }
      }
    }
    ruleExpString = ruleExpString.replace(/AND/g,"&&").replace(/OR/g,"||");
    let result = false;
   
      try{
        result= Function("return " + ruleExpString)();
      }
      catch(e)
      {
        result= false;
      }
    return result;
  }

  GetQDL(CQ_QID: number): Questions {
    
    let updateItem = this.questions.find(
      e => e.UniqueNumber == CQ_QID);
    if (updateItem != null && updateItem != undefined) {
      if(updateItem.QDLCondStatuses !=null && updateItem.QDLCondStatuses !=undefined 
        && this.ExecureRuleExpression(updateItem,updateItem.QDLCondStatuses[0].rule_expression)){
          let index = this.questions.indexOf(updateItem);
          return this.questions[index];
        }
    }
    

    return null;
  }

  setPiping(groupPiping: GroupPiping) {
    let updateItem = this.groupPipings.find(
      e => e.group_no == groupPiping.group_no);

    if (updateItem != null && updateItem != undefined) {
      let index = this.groupPipings.indexOf(updateItem);
      this.groupPipings[index] = groupPiping;
    } else {
      this.groupPipings.push(groupPiping);
    }
  }

  getPiping(group_no: number): string {
    let updateItem = this.groupPipings.find(
      e => e.group_no == group_no);

    if (updateItem != null && updateItem != undefined) {
      let index = this.groupPipings.indexOf(updateItem);
      return this.groupPipings[index].pipeTitle;
    }
    return null;
  }

  setMatrixPiping(matrixPiping: MatrixPiping) {
    let updateItem = this.matrixPipings.find(
      e => e.matrix_id == matrixPiping.matrix_id);

    if (updateItem != null && updateItem != undefined) {
      let index = this.matrixPipings.indexOf(updateItem);
      this.matrixPipings[index] = matrixPiping;
    } else {
      this.matrixPipings.push(matrixPiping);
    }
  }

  getMatrixPiping(matrix_id: number): string {
    let updateItem = this.matrixPipings.find(
      e => e.matrix_id == matrix_id);

    if (updateItem != null && updateItem != undefined) {
      let index = this.matrixPipings.indexOf(updateItem);
      return this.matrixPipings[index].pipeTitle;
    }
    return null;
  }

  setMatrixRandomList(matrix_id: number, uniqueList: any) {
    let updateItem = this.matrixRandomiseList.find(
      e => e.matrix_id == matrix_id);

    if (updateItem != null && updateItem != undefined) {
      updateItem.uniqueList = uniqueList;
      let index = this.matrixRandomiseList.indexOf(updateItem);
      this.matrixRandomiseList[index].uniqueList = uniqueList;
    } else {
      let matrixuniqueList: MatrixRandomiseList = new MatrixRandomiseList();
      matrixuniqueList.matrix_id = matrix_id;
      matrixuniqueList.uniqueList = uniqueList;
      this.matrixRandomiseList.push(matrixuniqueList);
    }
  }

  getMatrixRandomList(matrix_id: number): any {
    let updateItem = this.matrixRandomiseList.find(
      e => e.matrix_id == matrix_id);

    if (updateItem != null && updateItem != undefined) {
      let index = this.matrixRandomiseList.indexOf(updateItem);
      return this.matrixRandomiseList[index].uniqueList;
    }
    return null;
  }

  setIsCapchaMandatorySkip(isCapchaManditorySkip: boolean){
    this.isCapchaManditorySkip = isCapchaManditorySkip;
  }

  getIsCapchaMandatorySkip(){
    return this.isCapchaManditorySkip;
  }

  setPageIsSoftRequiredHandle(pageIsSoftRequiredHandle: boolean){
    this.pageIsSoftRequiredHandle = pageIsSoftRequiredHandle;
  }

  getPageIsSoftRequiredHandle(){
    return this.pageIsSoftRequiredHandle;
  }

  setNextButtonClickNo(nextButtonClickNo: number){
    this.nextButtonClickNo = nextButtonClickNo
  }

  getNextButtonClickNo(){
    return this.nextButtonClickNo;
  }

  getGeoLocation(): string{
    return this.geoLocation;
  }

  getProductName(): string{
    return this.productName;
  }

  getQuestionChange(): Questions {
    return this.questionchange;

  }
  setQuestionChange(questionchange: Questions) {
    this.questionchange = questionchange;
  }

  setAnswerPipeMessage(answerPipeMessage: string){
    this.answerPipeMessage = answerPipeMessage
  }

  getAnswerPipeMessage(): string{
    return this.answerPipeMessage;
  }
  setPrevPgChnge(isPrevPgChnge:boolean)
  {
    this.isPrevPgChnge = isPrevPgChnge;
  }
  getPrevPgChnge():boolean
  {
    return this.isPrevPgChnge;
  }

  showQuestion(element: any) {
    this.renderer.addClass(element, "active-ques");
    this.renderer.removeClass(element, "inactive-ques");
  }

  hideQuestion(element: any) {
    this.renderer.removeClass(element, "active-ques");
    this.renderer.addClass(element, "inactive-ques");
  }

  gotoNextQuestion(question: Questions, event) {
    if (this.getQuestionChange() && question.UniqueNumber == this.getQuestionChange().UniqueNumber && this.getQuestionChange().isValid && question.isValid) {
      return;
    }

    if($(event).closest('.active-ques').length == 0) {
      var tempInactive = $(event).closest('.inactive-ques');
      var tempActive = $('.active-ques');
      tempInactive.removeClass('inactive-ques');
      tempInactive.addClass('active-ques');
      tempActive.removeClass('active-ques');
      tempActive.addClass('inactive-ques');
    }

    var self = this;
    var elemQues = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').eq(0).find('.ques-overlay');
    var elemBtn = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').eq(0).find('.ques-response-btn');
    var elemBtnCount = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').eq(0).find('.ques-response-btn').length;
    var preElemBtnCount = $('.active-ques').find('.ques-response-btn').length;
    var nextbtnLength = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').length;
    var currElem = $('.active-ques');
    var noNextElem = true;
    var prevElem = $(event).closest('.active-ques');
    while(noNextElem) {
      var nextElem = prevElem.nextAll('.inactive-ques').has('.question-data').eq(0);
      if(nextElem.length > 0) {
        if(!(nextElem.find('.question-data').attr('hidden') == 'hidden')) {
          noNextElem = false;
        } else {
          prevElem = nextElem;
        }
      } else {
        noNextElem = false;
        nextbtnLength = 0;
      }
    }

    var minusScroll = 0;
    if($('.new-participation-focus').length > 0) {
      if(nextbtnLength > 0) {
        var elemPosition = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').eq(0).offset().top;


        $(window).unbind('scroll');
        $('body').off('mouseover', '.ques-overlay');

        $('html,body').animate({
          scrollTop: (elemPosition)
        }, 400, () => {
          if(nextElem.nextAll('.active-ques').length == 0)
          {
            currElem.removeClass('active-ques');
            currElem.addClass('inactive-ques');
            nextElem.addClass('active-ques');
            nextElem.removeClass('inactive-ques');
          }
          setTimeout(function() {
            self.lastScrollTop =  $(window).scrollTop();
            self.showNewParticipationScroll();
          }, 100);

          setTimeout(function() {
            $("body").on("mousemove", ".ques-overlay", function() {
              self.activateQuestionOnHover(this);
              $("body").on("mouseover", ".ques-overlay", function() {
                self.activateQuestionOnHover(this);
              });
            });
          }, 500);
        });
      } else {
        var scrollVal = $('.tblPageFooter').offset().top;
        $('html,body').animate({
          scrollTop: scrollVal
        }, 400, () => {
          if($('.next-button').length > 0) {
            $('.next-button').addClass('animateFooterIncrease');
          } else if($('.submit-button').length > 0) {
            $('.submit-button').addClass('animateFooterIncrease');
          }
          setTimeout(function() {
            if($('.next-button').length > 0) {
              $('.next-button').addClass('animateFooterDecrease');
            } else if($('.submit-button').length > 0) {
              $('.submit-button').addClass('animateFooterDecrease');
            }
          }, 250);
          setTimeout(function() {
            if($('.next-button').length > 0) {
              $('.next-button').removeClass('animateFooterIncrease');
              $('.next-button').removeClass('animateFooterDecrease');
            } else if($('.submit-button').length > 0) {
              $('.submit-button').removeClass('animateFooterIncrease');
              $('.submit-button').removeClass('animateFooterDecrease');
            }
          }, 450);
        });
      }
    } else {
    if(nextbtnLength > 0) {
      var elemPosition = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').eq(0).offset().top;
      elemPosition = elemPosition -50;
      if(elemQues.outerHeight() > $(window).height()){
        if(elemBtnCount > 0 && preElemBtnCount > 0){
          minusScroll = (elemBtn.outerHeight() * 2) - 10;
        } else {
          if(elemBtnCount > 0){
            minusScroll = elemBtn.outerHeight();
          } else if(preElemBtnCount > 0){
            minusScroll = $('.active-ques').find('.ques-response-btn').outerHeight() + 15;
          } else {
            minusScroll = 0;
          }
        }
      } else {
        if(elemBtnCount > 0 && preElemBtnCount > 0){
          //minusScroll = ($(window).height() - elemQues.outerHeight())/2 - (elemBtn.outerHeight() * 2);
          minusScroll = ($(window).height() - elemQues.outerHeight())/2 - 10;
        } else {
          if(elemBtnCount > 0){
            minusScroll = ($(window).height() - elemQues.outerHeight())/2 - elemBtn.outerHeight();
          } else if(preElemBtnCount > 0) {
            minusScroll = ($(window).height() - elemQues.outerHeight())/2 + $('.active-ques').find('.ques-response-btn').outerHeight();
          } else {
            minusScroll = ($(window).height() - elemQues.outerHeight())/2;
          }
        }
      }
      $('html,body').animate({
        scrollTop: (elemPosition - minusScroll)
      }, 400, () => {
        if(elemQues.closest('.active-ques').length == 0) {
          currElem.removeClass('active-ques');
          currElem.addClass('inactive-ques');
          nextElem.addClass('active-ques');
          nextElem.removeClass('inactive-ques');
        }
      });
    } else {
      var scrollVal = $('.tblPageFooter').offset().top;
      $('html,body').animate({
        scrollTop: scrollVal
      }, 400);
    }
  }
  }

  activateQuestion(obj, objPos, direction){
    //objPos is the position + ht of the current active question
    var switchPosition = $(window).height() * 0.5;
    var switchPosition2 = $(window).height() * 0;
    var switchPosition3 = $(window).height() * 0.7;
    if(direction == 'down') {
      var nextElement = obj.nextAll('.inactive-ques').has('.question-data').eq(0);
      if(objPos < switchPosition && objPos  && nextElement.length > 0){
        nextElement.addClass('active-ques');
        nextElement.removeClass('inactive-ques');
        obj.removeClass('active-ques');
        obj.addClass('inactive-ques');
      }
    } else {
      var prevElement = obj.prevAll('.inactive-ques').has('.question-data').eq(0);
      if (prevElement.length > 0) {
        var prevElemPos = (obj.prevAll('.inactive-ques').has('.question-data').eq(0).offset().top - $(window).scrollTop());
        var prevElemPosWithHt = (obj.prevAll('.inactive-ques').has('.question-data').eq(0).offset().top - $(window).scrollTop()) + obj.prevAll('.inactive-ques').has('.question-data').eq(0).outerHeight();
        if ((prevElemPos >= switchPosition2 || prevElemPosWithHt > switchPosition3) && prevElement.length > 0) {
          prevElement.addClass('active-ques');
          prevElement.removeClass('inactive-ques');
          obj.removeClass('active-ques');
          obj.addClass('inactive-ques');
        }
      }
    }
  }

  lastScrollTop: number = 0;
  showNewParticipationScroll() {
    let self = this; 
    $(window).scroll(function () {
      if ($('.active-ques').length > 0) {
        var activeElemPos = $('.active-ques').offset().top + $('.active-ques').outerHeight() - $(window).scrollTop();
        if (self.lastScrollTop != 0 && !($(window).scrollTop() < 0 || self.lastScrollTop < 0) && $(window).scrollTop() != self.lastScrollTop) {
          if ($(window).scrollTop() >= self.lastScrollTop) {
            self.activateQuestion($('.active-ques'), activeElemPos, 'down');
          } else {
            self.activateQuestion($('.active-ques'), activeElemPos, 'up');
          }
        }
        self.lastScrollTop = $(window).scrollTop();
      }
    });
  }

  activateQuestionOnHover(element) {
    if(this.surveyFormat == 1)
    {
      $('.active-ques').addClass('inactive-ques');
      $('.active-ques').removeClass('active-ques');
      $(element).closest('.inactive-ques').addClass('active-ques');
      $(element).closest('.inactive-ques').removeClass('inactive-ques');
      $('body').off('mousemove', '.ques-overlay');
    }
  }

  setSelectedLanguageCulture(selectedLanguageCulture: string) {
    this.selectedLanguageCulture = selectedLanguageCulture;
  }

  getSelectedLanguageCulture() {
    return this.selectedLanguageCulture;
  }

  setSelectedLanguage(selectedLanguage: number) {
    this.selectedLanguageId = selectedLanguage;
  }

  getSelectedLanguage(): number {
    return this.selectedLanguageId;
  }
}
